// extracted by mini-css-extract-plugin
module.exports = {"cropperContainer":"crop-image_cropperContainer__3pD-I","buttons":"crop-image_buttons__2NFtx"};